export interface Mp3ValidationResult {
  isValid: boolean;
  error?: string;
}

export function validateMp3File(file: File): Mp3ValidationResult {
  const isMp3Type = file.type === 'audio/mpeg';
  const isMp3Extension = file.name.toLowerCase().endsWith('.mp3');

  if (!isMp3Type || !isMp3Extension) {
    return {
      isValid: false,
      error: 'Only MP3 files are allowed.',
    };
  }

  return {isValid: true};
}
